// ConsolidadosList.jsx
import React, { useEffect, useRef, useState } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import SoftBox from 'components/SoftBox';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';

// Importa tus modales
import ModalFiltros from './components/ModalFiltros';
import ModalCargarConsolidado from './components/ModalCargarConsolidado';
import ModalDownloadData from './components/ModalDownloadData'; // Modal para descargar datos

// Data estática o simulada para la tabla
import fetchData from 'layouts/pages/finantial/consolidados/data/dataTableData';

const ConsolidadosList = () => {
  const currentPageData = useRef([]);
  const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });
  const [isLoading, setIsLoading] = useState(true);

  const getData = async () => {
    setIsLoading(true);
    try {
      const data = await fetchData();
      setDataTableData(data);
    } catch (error) {
      console.error('Error al cargar los datos:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const onApplyFilters = async (filters) => {
    setIsLoading(true);
    try {
      // Aplica tus filtros aquí
    } catch (error) {
      console.error('Error al aplicar filtros:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Callback cuando se carga el consolidado
  const handleUploadConsolidado = (data) => {
    console.log('Consolidado cargado:', data);
    getData();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <DataTableHeaderOptions
        dataTableData={dataTableData}
        FilterModal={ModalFiltros}
        ModalDownloadData={ModalDownloadData}  // Se pasa el modal para descarga de datos
        getData={getData}
        CreateNewModal={ModalCargarConsolidado}
        createNewTitle="Cargar Consolidados"
        currentPageData={currentPageData}
        onApplyFilters={onApplyFilters}
        onUploadConsolidado={handleUploadConsolidado}
        initialFilters={{ /* tus filtros iniciales si es necesario */ }}
      />
      <SoftBox my={3}>
        <Card>
          {isLoading ? (
            <div>Cargando datos...</div>
          ) : (
            dataTableData.rows &&
            Array.isArray(dataTableData.rows) && (
              <DataTable
                onPageData={(data) => {
                  currentPageData.current = data;
                }}
                canSearch={true}
                entriesPerPage={true}
                showTotalEntries={true}
                table={dataTableData}
              />
            )
          )}
        </Card>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
};

export default ConsolidadosList;
